// extracted by mini-css-extract-plugin
export var content = "_d0-3";
export var list = "_d0-4";
export var settingsContent = "_d0-7";
export var settingsPanel = "_d0-8";
export var state = "_d0-6";
export var triggerBadge = "_d0-2";
export var triggerButton = "_d0-1";
export var triggerShell = "_d0-0";
export var unreadDot = "_d0-5";